import { ElementState } from "@creatomate/preview";
import { ElementPlacement } from "chq";

// validate same track overlapping
const validateSameTrackOverlapping = (
  trackElements: ElementState[], nextElementPlacement: ElementPlacement, element: ElementState
): ElementState | undefined => {
  const invalidTrackElements = trackElements?.filter(
    trackElement => {
      const elementEndTime = trackElement.localTime + trackElement.duration;
      return elementEndTime > nextElementPlacement.time
        && trackElement.localTime < (nextElementPlacement.time + nextElementPlacement.duration)
        && element.source.id !== trackElement.source.id;
    }
  );

  if (invalidTrackElements && invalidTrackElements.length > 0) return invalidTrackElements[0];

  return undefined;
};

export default validateSameTrackOverlapping;
